export const toNum = (v: unknown) => {
	const n = Number(v);
	return Number.isFinite(n) ? n : 0;
};

export const roundElo = (elo: unknown) => Math.round(Number(elo) || 0);

export function formatDecimal(number: number | string | null | undefined, decimals = 1) {
	if (number === null || number === undefined) return '0';
	const fixed = Number(number).toFixed(decimals);
	return fixed.replace(/\.0+$/, '');
}
